import EditRoundedIcon from "@mui/icons-material/EditRounded";

export const editPen = (props) => {
  return <EditRoundedIcon {...props} />;
};
